<!--
 * @Description: 报名成功信息页
 * @Author: 山淑兰
 * @Date: 2019-11-11 17:39:20
 * @LastEditTime: 2020-07-15 18:03:43
 * @LastEditors: 山淑兰
 -->
<template>
    <div id="hotelList">
        <Loading v-if="show"></Loading>
        <div class="hotelList_container">
            <header class="hotel-header">
                <div class="header-left">
                    <!-- <img src="../../assets/return-white.png">  -->
                </div>
                <div class="header-title">
                    订单列表
                </div>
                <div class="header-right">
                </div>
            </header>
            <div class="hotelList_content">
                <div class="order-list" 
                    v-for="(item,index) in hotelRecords"  :key='index'
                    @click="goOrderDetail($event,item.hrcid)">
                    <div class="order-date">
                        预定日期：{{changeDate(item.CreaTime,8)}}
                    </div>
                    <div class="order-detail">
                        <div class="hotel-name">
                            <img src="../../assets/order-hotel-1.png"> 
                            {{item.Hotel_BasicinfoEntity.hotellname}}
                        </div>
                        <div class="hotel-add">
                            {{item.Hotel_BasicinfoEntity.hoteladdress}}
                        </div>
                        <div class="order-dateRange">
                            {{changeDate(item.Checkintime,8)}}-{{changeDate(item.Checkouttime,8)}}
                            <span>{{item.rescount}}间 • {{item.days}}晚</span>
                        </div>
                        <div class="hotel-text">
                            {{item.showname}} (可入住{{item.canpeople}}人)
                        </div>
                        <div class="order-status" v-if="item.state==0">
                            <div class="order-pay"  v-if="item.paystatus==1">
                                <span class="goMore">更多</span>
                                <span @click.stop="goCancel($event,item.hrcid)">取消</span>
                                <span @click.stop="goInvoice($event)">开发票</span>
                                
                            </div>
                            <div class="order-pay"  v-if="item.paystatus==0">
                                <span @click.stop="goOrder($event,item.hrcid,item.showname)">再次预定</span>
                                <span @click.stop="goCancel($event,item.hrcid)">取消</span>
                                <span class="goPay" @click.stop="goPay($event,item.muid,item.hrcid)">去支付</span>
                            </div>
                        </div>
                        <div class="order-status" v-if="item.state==1">
                            <div class="order-yd">
                                <span>预定失败</span>
                            </div>
                            <div class="order-pay">
                                <span>原因</span>
                            </div>
                        </div>
                        <div class="order-status" v-if="item.state==2">
                            <div class="order-yd">
                                <span>已取消</span>
                            </div>
                        </div>
                        <div class="order-status" v-if="item.state==3">
                            <div class="order-yd">
                                <span>审核中</span>
                            </div>
                        </div>
                        <div class="order-status" v-if="item.state==4">
                            <div class="order-yd">
                                <span>审核失败</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="loading" v-if="loading">
                    <van-loading type="spinner" color="#3b82f6" vertical size="30px" text-size="14px">加载中...</van-loading>
                </div>
                <div class="tips-box" v-if="tipsVisible">
                    <div class="tips-con">
                        <div class="tips-text">
                            确定取消该订单么？
                        </div>
                        <div class="tips-group">
                            <div class="tips-group-btn" @click="closeTips()">
                                取消
                            </div>
                            <div class="tips-group-btn" @click="sureTips()">
                                确定
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Loading from '@components/Loading.vue'
import Footer from '@components/Footer.vue'
import publicSignup from '../../lib/signUp.js'
import wxShare from '../../lib/wxShare.js'
export default {
    name: 'hotelOrderList',
    components: {
        Loading,
    },
    data() {
        return {
          publicSignup: {}, //通用js
          params: {
              m: '',
          },
          meetingInfo: '',
          show: false,
          loading: false,
          navShow: true,
          navhomeUrl: '',
          hotelRecords: [],
          hrcid: '',
          tipsVisible: false,
        }
    },
    created() {
        this.params = this.$route.query
        this.publicSignup = new publicSignup()
        console.log(this.publicSignup)
        let opt = { m: this.params.m }
        this.initmeeting(opt)
        this.hotelOrder()
    },
    mounted() {
        //this.swiperInit()
    },
    methods: {
        //时间转换
        changeDate(date,num){
            if( date != '' && date != null && date){
                if( date.length == 16 ){
                    num = num
                }else if( date.length == 17 ){
                    num = num + 1
                }else if( date.length == 18 ){
                    num = num + 2
                }
                var dateNew = date.substring(0, num)
                return dateNew.replace(new RegExp("/","gm"),"-")
            }

        },
        async initmeeting(opt) {
            this.show = true
            this.meetingInfo = await this.publicSignup.init(opt, this)
            if (this.meetingInfo.Code === 1000) {
                this.show = false
                if (this.meetingInfo.HomeUrl == null || this.meetingInfo.HomeUrl == '') {
                    this.navShow = false
                } else {
                    this.navShow = true
                    this.navhomeUrl = this.meetingInfo.HomeUrl
                }
                
            } else {
                this.$notify({
                    massage: this.meetingInfo.Msg,
                    type: 'danger',
                    duration: '3000',
                })
            }
        },
        /**
         * 初始化订单列表
         */
        async hotelOrder() {
            let opt = { m: this.params.m }
            try {
                this.loading = true
                let res = await this.$http.hotelOrder(opt)
                console.log(res)
                if (res.Code === 1000) {
                    this.loading = false
                    this.hotelRecords = res.hotel_Hotel_Records
                } else {
                    this.$notify({
                        message: res.Msg,
                        type: 'primary',
                    })
                }
            } catch (err) {
                console.log(err)
            }
        },

        
        goBack(){
            this.$router.go(-1);
        },
       
        //取消订单
        async hotelOrderCancel(hrcid) {
            let opt = { hrcid: hrcid}
            try {
                let res = await this.$http.hotelOrderCancel(opt)
                console.log(res)
                if (res.Code === 1000) {
                    this.tipsVisible = false
                    this.$notify({
                        message: '取消成功',
                        type: 'primary',
                    })
                    this.hotelOrder()
                } else {
                    this.$notify({
                        message: res.Msg,
                        type: 'danger',
                    })
                }
            } catch (err) {
                console.log(err)
            }
        },
        goCancel(e,hrcid){
            this.tipsVisible = true
            this.hrcid = hrcid
        },
        closeTips(){
            this.hrcid = ''
            this.tipsVisible = false
        },
        sureTips(){
            this.hotelOrderCancel(this.hrcid)
        },
        //再次预定
        async hotelOrdeRebook(hrcid,showname) {
            let opt = { hrcid: hrcid}
            try {
                let res = await this.$http.hotelOrdeRebook(opt)
                console.log(res)
                if (res.Code === 1000) {
                    // this.$notify({
                    //     message: '预定成功',
                    //     type: 'primary',
                    // })
                    const hotelRecord = {
                        mid: this.params.m,
                        hid: res.hotel_Hotel_Record.hid,
                        showname: showname,
                        hotellname: res.hotel_Hotel_Record.Hotel_BasicinfoEntity.hotellname,
                        hrtname: res.hotel_Hotel_Record.hrtname,
                        resname: res.hotel_Hotel_Record.resname,
                        resphone: res.hotel_Hotel_Record.resphone,
                        identitycard: res.hotel_Hotel_Record.identitycard,
                        dateRange: res.hotel_Hotel_Record.days,
                        checkintime: res.hotel_Hotel_Record.Checkintime,
                        checkouttime: res.hotel_Hotel_Record.Checkouttime,
                        restype: res.hotel_Hotel_Record.restype,
                        rescount: res.hotel_Hotel_Record.rescount,
                        ArrivalTime: res.hotel_Hotel_Record.arrivaltime,
                        Remark: res.hotel_Hotel_Record.Remark,
                    }
                    localStorage.setItem("orderDetail",JSON.stringify(hotelRecord))
                    const params = {
                        m: this.params.m,
                        hrcid: hrcid,
                    }
                    this.$router.push({
                        path: '/hotelOrder',
                        query: params,
                    })
                    
                } else {
                    this.$notify({
                        message: res.Msg,
                        type: 'danger',
                    })
                }
            } catch (err) {
                console.log(err)
            }
        },
        goOrder(e,hrcid,showname){
            this.hotelOrdeRebook(hrcid,showname)
        },  
        goOrderDetail(e,hrcid){
            const params = {
                m: this.params.m,
                hrcid: hrcid,
            }
            this.$router.push({
                path: '/hotelOrderDetail',
                query: params,
            })
        },
        goInvoice(){
            const params = {
                m: this.params.m
            }
            this.$router.push({
                path: '/hotelInvoice',
                query: params,
            })
        },
        goPay(e,muid,hrcid){
            const params = {
                m: this.params.m,
                muid: muid,
                hrcid: hrcid
            }
            this.$router.push({
                path: '/hotelInitPay',
                query: params,
            })
        },
        //微信分享
        async initShare(title, desc, link, imgUrl) {
            try {
                const headRes = await this.$http.csData({
                    url: encodeURIComponent(
                        window.location.href.replace(location.hash, '')
                    ),
                })
                console.log(headRes, 'headRes')
                const _Wx = new wxShare({
                    opt: headRes,
                })
                _Wx.ready().then((wx) => {
                  _Wx.share(title, desc, link, imgUrl)
                  console.log(wx)
                })
                //this.headRess = _Wx
            } catch (err) {
                console.log(err)
            }
        },
        //微信发票抬头
        async invoice(){
            try {
                const headRes = await this.$http.csData({
                    url: encodeURIComponent(
                        window.location.href.replace(location.hash, '')
                    ),
                })
                console.log(headRes, 'headRes')
                const _Wx = new wxShare({
                    opt: headRes,
                })
                _Wx.invoice('chooseInvoiceTitle',{ "scene":"1" }, function(res) {
                    console.log('res', res)
                })
                //this.headRess = _Wx
            } catch (err) {
                console.log(err)
            }

            // window.WeixinJSBridge.invoke(
            //   'chooseInvoiceTitle',
            //   { "scene":"1" },
            //   function(res) {
            //     window.WeixinJSBridge.log(res.err_msg)
            //     console.log('res', res)
            //   }
            // )
            // const headRes = await this.$http.csData({
            //     url: encodeURIComponent(
            //         window.location.href.replace(location.hash, '')
            //     ),
            // })
            // const _Wx = new wxShare({
            //     opt: headRes,
            // })
            // console.log(_Wx)
            // _Wx.ready().then((wx) => {
            //     _Wx.invoice()
            //     console.log(wx)
            // })
        },
    },
}
</script>
<style lang="scss" scoped>
    .hotel-header{
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        height: 80px;
        background: linear-gradient(135deg, #0f172a 0%, #1e3a5f 50%, #1e5fa8 100%);
        display: flex;
        align-items: center;
        .header-left,
        .header-right{
            width: 100px;
            text-align: center;
            img{
                width: 40px;
                height: 40px;
            }
        }
        .header-title{
            flex: 1;
            text-align: center;
            font-size: 30px;
            color: #fff;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
        }
    }
    .hotelList_content{
        padding: 90px 20px 20px;
        .order-list{
            border-raduis: 5px;
            padding: 20px 0;
            margin-bottom: 20px;
            border-radius: 10px;
            background: #ffffff;
            .order-date{
                font-size: 26px;
                color: #fff;
                border-radius: 10px;
                background: #3b82f6;
                border-radius: 10px;
                padding: 0 30px;
                display: inline-block;
            }
            .order-detail{
                background: #fffffffff;
                padding: 20px;
                margin-top: 20px;
            }
            .hotel-name{
                font-size: 32px;
                color: #1e293b;
                font-weight: bold;
                img {
                    width: 36px;
                    height: 36px;
                    vertical-align: -4px;
                }
            }
            .hotel-add{
                font-size: 28px;
                color: #1e293b;
                margin-top: 10px;
                
            }
            .hotel-text{
                font-size: 28px;
                color: #1e293b;
                margin-top: 10px;
            }
            .order-status{
                display: flex;
                margin-top: 15px;
                div{
                    flex: 1;
                    display: flex;
                    justify-content: flex-end;
                    span{
                        padding: 0 20px;
                        height: 50px;
                        text-align: center;
                        line-height: 50px;
                        font-size: 28px;
                        border: 1px solid #e2e8f0;
                        border-radius: 10px;
                        margin-left: 15px;
                        background: #ffffff;
                    }
                    span.goMore{
                        border: none;
                        height: 52px;
                        line-height: 52px;
                    }
                    span.goPay{
                        background-image: linear-gradient(135deg, #3b82f6, #6366f1);
                        color: #fff;
                        border: none;
                        height: 52px;
                        line-height: 52px;
                    }
                }
            }
            .order-dateRange{
                font-size: 30px;
                color: #1e293b;
                margin-top: 10px;
                span{
                    margin-left: 20px;
                }
            }
        }
    }
    .tips-box{
        position: fixed;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        z-index: 999;
        background: rgba(0,0,0,.5);
        .tips-con{
            position: absolute;
            width: 70%;
            height: 200px;
            background: #ffffff;
            top: 50%;
            left: 50%;
            z-index: 1000;
            transform: translate(-50%,-50%);
            font-size: 30px;
            text-align: center;
            border-radius: 20px;
            overflow: hidden;
            .tips-text{
                height: 110px;
                line-height: 110px;
            }
            .tips-group{
                display: flex;
                height: 90px;
                border-top: 1px solid #e2e8f0;
                >div{
                    flex: 1;
                    line-height: 90px;
                }
                >div:last-child{
                    background: #3b82f6;
                    color: #fff;
                }
            }
        }
    }
</style>
<style type="text/css">
    /*.van-notify{
        padding: 25px 10px;
        font-size: 14px;
    }*/
</style>